import {
    find,
    flatten,
    mapValues,
    pick as lodashPick,
    sortBy,
    uniq,
    value,
    values,
    size,
} from 'lodash-es'

export function pick(object, properties) {
    return properties.reduce((pickedObject, property) => {
        pickedObject[property] = object[property]
        return pickedObject
    }, {})
}

const BYTE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB']

export function formatBytes(bytes, decimals = 1) {
    if (!bytes) {
        return null
    }

    let size = bytes
    let unit = 0

    while (size >= 1024 && unit < BYTE_UNITS.length - 1) {
        size /= 1024
        unit++
    }

    return `${unit === 0 ? size : size.toFixed(decimals)} ${BYTE_UNITS[unit]}`
}

const chainableFunctions = {
    sortBy,
    find,
    value,
    values,
    pick: lodashPick,
    flatten,
    uniq,
    size,
}

// See https://github.com/lodash/lodash/issues/3298#issuecomment-341685354
export const chain = (input) => {
    let value = input
    const wrapper = {
        ...mapValues(chainableFunctions, (f) => (...args) => {
            value = f(value, ...args)
            return wrapper
        }),
        value: () => value,
    }
    return wrapper
}
